export function getSignupServiceTypeFromCookie(): 'NOVA' | 'BUS' {
  return document.cookie.includes('signupServiceType=NOVA') ? 'NOVA' : 'BUS';
}

export function clearSignupServiceTypeCookie(): void {
  document.cookie = 'signupServiceType=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
}
